// 老用户平稳迁移：未确认当前账号的微信登录绑定前，保留历史密码；新记录只写账号。
const parse=(storage:Storage,key:string)=>{try{return JSON.parse(storage.getItem(key)||'null')}catch{return null}}
const accountValue=(value:any)=>value?.remebmer===true && typeof value.username==='string' && value.username.trim()?value:null
export function readRememberedAccount(storage:Storage,key:string){
 const legacy=accountValue(parse(storage,key)),modern=parse(storage,key+':account')
 if(modern && modern.remebmer===false)return {username:'',password:'',remebmer:false}
 const selected=accountValue(modern)||legacy
 if(!selected)return {username:'',password:'',remebmer:false}
 return {username:selected.username,password:legacy?.username?.trim()===selected.username.trim() && typeof legacy.password==='string'?legacy.password:'',remebmer:true}
}
export function rememberAccount(storage:Storage,key:string,input:any){
 try{
  const value=input?.remebmer===true && typeof input.username==='string' && input.username.trim()?{username:input.username.trim(),remebmer:true}:{remebmer:false}
  // 独立写入账号选项，不覆盖、删除另一账号或尚未迁移的旧密码。
  storage.setItem(key+':account',JSON.stringify(value))
  const legacy=parse(storage,key)
  if(!legacy || !legacy.password){if(value.remebmer)storage.setItem(key,JSON.stringify(value));else storage.removeItem(key)}
 }catch{/* 浏览器禁用存储不阻断登录。 */}
}
export function clearLegacyPasswordAfterWechatBinding(storage:Storage,key:string,proof:any,actor:{id:number;orgId:number;role?:'org'|'cus'}){
 if(actor.role && proof?.role!==actor.role)return false
 if(proof?.bound!==true || Number(proof.accountId)!==Number(actor.id) || Number(proof.orgId)!==Number(actor.orgId) || !(Number(actor.id)>0) || !(Number(actor.orgId)>0))return false
 const legacy=parse(storage,key)
 if(!legacy || typeof legacy.username!=='string' || typeof legacy.password!=='string')return false
 const username=legacy.username.trim()
 const aliases=[proof.loginName,proof.phone].filter(x=>typeof x==='string' && x.trim()).map(x=>x.trim())
 if(!aliases.includes(username) || (legacy.orgId!=null && Number(legacy.orgId)!==Number(actor.orgId)))return false
 if(legacy.id!=null && Number(legacy.id)!==Number(actor.id))return false
 try{storage.setItem(key,JSON.stringify({username:legacy.username,remebmer:legacy.remebmer===true}));return true}catch{return false}
}
